var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HomeNestleTop'),_c('div',{staticClass:"container"},[_c('h1',{staticClass:"nestleSlogan"},[_vm._v(_vm._s(_vm.$t('home.sloganNestle')))])]),_c('NestleHomeSteps'),_c('div',{staticClass:"mb-5 mt-5"},[_c('Avantages')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }